<template>
  <div class="h5mycenterPage">
    <div class="mysettingright">
       <div>
          <img src="@/assets/img/my/my_msg.png" alt="" @click="toutsideUrl(1)">
          <!-- <img src="@/assets/img/my/my_listen.png" alt="">-->
         <img src="@/assets/img/my/my_setting.png" alt="" @click="toutsideUrl(2)">
       </div>
    </div>
    <div class="myuser">
      <div class="left">
        <div class="header">
          <img :src="user.headimgurl" alt="">
        </div>
        <div class="name">
          <div class="nickname">{{user.nickname}}</div>
          <div class="userid">ID:{{ user.userid }}</div>
        </div>
      </div>
      <!-- <div class="right">
        <div class="box">
          <div class="box_left">
            <img src="@/assets/img/my/my_jifen.png" alt="">
            <span>账户积分</span>
          </div>
          <div class="box_right" @click="ToJifen">
            <div class="num">{{Jifen}} <img src="@/assets/img/my/my_right_red.png" alt=""></div>
          </div>
        </div>
      </div> -->
    </div>
     
    <div class="order_container mynavcard">
      <div class="info">
          <div class="img" v-for="item in iconArr" :key="item.id" @click="ToIconUrl(item.href)">
            <img :src="item.pic | isImage" alt="">
            <div>{{ item.title }}</div>
          </div>
      </div>
    </div>

    <!-- 订单中心 -->
    <!-- <div class="my_order" >
      <div class="left">订单中心</div>
      <div class="right" @click="ToDingdan">全部订单 <img src="@/assets/img/my/my_right_hui.png" alt=""></div>
    </div> -->

    <!-- <div class="order_container">
      <div class="info">
          <div class="img">
            <img src="@/assets/img/my/my_payment.png" alt="">
            <div>待付款</div>
          </div>
          <div class="img">
            <img src="@/assets/img/my/my_sendOk.png" alt="">
            <div>已付款</div>
          </div>
          <div class="img">
            <img src="@/assets/img/my/my_beforeSend.png" alt="">
            <div>待发货</div>
          </div>
          <div class="img">
            <img src="@/assets/img/my/my_sending.png" alt="">
            <div>待收货</div>
          </div>
          <div class="img">
            <img src="@/assets/img/my/my_hasPayment.png" alt="">
            <div>已完成</div>
          </div>
          <div class="img">
            <img src="@/assets/img/my/my_refund.png" alt="">
            <div>退款</div>
          </div>
      </div>
          
    
    </div> -->
    
    <!-- 轮播图 -->
    <div class="my_lunbo" v-if="swiperList.length > 0" >
       <wc-swiper :autoplay="false" :interval="2000" @transitionend="fn" class="wc_1swiper">
          <wc-slide v-for="(item, key) in swiperList" :key="key">
             <a :href="item.href == null ? '' : item.href"> <img :src="item.pic | isImage" alt="" class="my_lunbo_img"> </a>
          </wc-slide>
        </wc-swiper>
    </div>

        <!-- 频道 -->
    <div class="my_channer" v-if="channelArr.length > 0">
      <div class="left">看购其他业务频道</div>
      <!-- <img src="@/assets/img/my/my_right_hui.png" alt=""> -->
    </div>

  <!-- 看购电影 -->
    <div class="my_footer_movie">

        <div class="box" v-for="(item, index) in channelArr" :key="index + 'box_one'" >
          <div>
            <div class="box_one">
              <img :src="item.logo_pic | isImage " alt="" >{{item.title}}
            </div>
            <div class="box_two">
              <img :src="item.pic | isImage" alt="" >
            </div>
            <div :class="item.btn_title2 ? 'box_three1' : 'box_three' ">
              <span @click="ToBtnUrl(item.href1)">{{item.btn_title}}</span>
              <span v-if="item.btn_title2" @click="ToBtnUrl(item.href2)">{{item.btn_title2}}</span>
            </div>
          </div>
        </div>

    </div>
  </div>
</template>

<script defer=true>

import * as api from "@/api";
import JmmToast from '@/components/JmmToast'
import wx from "weixin-js-sdk";
export default {
  name: "my",
  data() {
    return {
      user: {},
      token: 'jjcimpilpgejfeehkdinjlbgabbgchhe',
      appid: "",
      showSlider: false,
      toJifenUrl: '',   // 跳转积分地址
      Jifen: '',         // 积分
      sign: '',
      type: '',           // 判断频道,渠道 参数传参要求
      list: '',
      iconArr: '',    // 图标数组
      swiperList: [],
      channelArr: [],  // 渠道数组
      merchantId: '',
      cityLogo: "",   // 城市logo
      displayType: "",   // 账户显示色调
      stateId: ''
    }
  },
  created() {
    this.merchantId = this.$route.query.merchantId;
    this.stateId = this.$route.query.state;
    if(null != this.merchantId && undefined != this.merchantId && "merchantId" != this.merchantId){
      localStorage.setItem('cityMerchantId', this.merchantId);
    } else if(null != this.stateId && undefined != this.stateId && "merchantId" != this.stateId){
      this.merchantId = this.stateId;
      localStorage.setItem('cityMerchantId', this.merchantId);
    } else {
      localStorage.setItem('cityMerchantId', "");
    }
    this.isRecharge = this.$route.query.isRecharge

    this.type = this.$route.query.type

    this.getwebAppId()
  },
  filters: {
     isImage(value) {
      // let devUrl = 'https://kangou-user-center.oss-cn-beijing.aliyuncs.com/test/' + value
      let prodUrl = 'https://kangou-user-center.oss-cn-beijing.aliyuncs.com/prop/' + value
      return prodUrl
    },
  },
  mounted() {},
  methods: {
    toutsideUrl(can) {
      let meUrl = `info.html#/?token=${this.token}&sign=${this.sign}`
      // let messageUrl = 'https://filmapitest.kangou.cn/#/news?userSign=' + this.sign
      let messageUrl = `https://amuse.kangou.cn/#/news?userSign=${this.sign}`
       can == 2 ? window.location.href = meUrl : 
       can == 1 ? window.location.href = messageUrl : 
        ''
    },
    ToBtnUrl(can) {
       window.location.href = can.includes('http') ? can : 'http://' + can
    },
    getUrlCode() { // 截取url中的code方法
      var url = location.search
      var theRequest = new Object()
      if (url.indexOf("?") != -1) {
          var str = url.substr(1)
          var strs = str.split("&")
          for(var i = 0; i < strs.length; i++) {
              theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1])
            }
          }
        return theRequest
    },
    // 获取城市appId
    async getwebAppId(){
      try {
        let info = {}
        const res = await api.user.getwebAppId(info)
        if (res.code == "000000") {
          this.appid = res.data.appId;
          this.cityLogo = res.data.logo;
          this.displayType = res.data.displayType;
          if(this.cityLogo == null || this.cityLogo == undefined){
            this.cityLogo = "";
          }
          localStorage.setItem('cityLogo', this.cityLogo);
          localStorage.setItem('displayType', this.displayType);
          this.getCode();
        } else {
          this.getCode();
        }
      } catch (err) {
        this.getCode();
        console.log(err)
      }      
    },
    // 2 非静默授权，第一次有弹框
    getCode(){ 
      this.code = ''
      var local = window.location.href // 获取页面url
      if(local.indexOf("?code=") != -1 && local.indexOf("#/?") != -1){
        // 获取授权后的code位置
        var codeBeg = local.indexOf("?code=");
        var codeEnd = local.indexOf("#/?");
        // 截取授权后的code数据
        var codeCut = local.substring(codeBeg, codeEnd);
        local = local.replace(codeCut, "");
      }
      this.code = this.getUrlCode().code // 截取code
      if (!this.code) { // 如果没有code，则去请求
          window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&state=${this.merchantId}&connect_redirect=1#wechat_redirect`
      } else {
        var merchantIdState = this.getUrlCode().state // 截取state
        if(null == merchantIdState || undefined == merchantIdState){
          merchantIdState = '';
        }
        if('' == this.merchantId && '' != merchantIdState){
          this.merchantId = merchantIdState;
          localStorage.setItem('cityMerchantId', this.merchantId);
        }
        // 通过code获取信息 
        this.fetch(this.code)
      }
    },
    // 3  code 登录
    async fetch(codeNum) {
      let that = this
      let info = { "appId": this.appid, "wxcode": codeNum }
      localStorage.setItem('reToken', this.token)
      const res = await api.user.webLogin(info)
      if (res.code == '000000') {
        that.sign = res.data.sign
        // localStorage.setItem('reSESSIONKEY', res.data.SESSIONKEY)
        localStorage.setItem('codeSign', res.data.sign)

        that.user['nickname'] = res.data.nickname
        that.user['headimgurl'] = res.data.headimgurl
        that.user['userid'] = res.data.userid

        that.$forceUpdate()

        that.getAll(res.data.sign)
        // this.ToIntegral()
        // 测试渠道接口

      } else {
        if (res.code == '40163' || res.code == '40029') {
          var local = window.location.href // 获取页面url
          if(local.indexOf("?code=") != -1 && local.indexOf("#/?") != -1){
            // 获取授权后的code位置
            var codeBeg = local.indexOf("?code=");
            var codeEnd = local.indexOf("#/?");
            // 截取授权后的code数据
            var codeCut = local.substring(codeBeg, codeEnd);
            local = local.replace(codeCut, "");
          }
          // 重新访问 此路径地址
          window.location.href = local;
          // window.location.href = `https://${window.location.host}/my.html#/?timer=${new Date().getTime()}`
        }
      }
    },

    // 4 获取轮播图
    getAll: async function(sign) {
      try {
      localStorage.setItem('reToken', this.token)
      let params = { "cardType": "17", "cardRights": "4001", "sign": sign, "getIntegral" : this.isRecharge == 1 ? "1" : '' }
      // api.user.getIntgerCard(params)
      let query = { sign: this.type == undefined ? sign : '', type: this.type == undefined ? '' : this.type }
       const [resLunbo, resMore, resOther] = await Promise.all([
        api.user.getAdvertisFront(), api.user.getMulFront({ 'status': 1 }), api.user.getOtherFront(query)
       ])
        this.swiperList = resLunbo.data
        this.iconArr = resMore.data
        // this.Jifen = resIntger.data[0].cardticketremaincount
        this.channelArr = resOther.data
      } catch (error) {
        console.log(error, '页面渲染效果')
      }
    },
       // 4.1 跳转积分页面
    async ToIntegral(){
        const res = await api.user.getIntegralsign()
          if (res.code == '000000') {
            let dataJson = { 
              goodsType: 50000, 
              backUrl:window.location.href + '&isRecharge=1',
              number: 1,
              notifyUrl: `https://accountapi.kangou.cn/api/code/huidiaoPost`,
              // notifyUrl: 'https://test2.gonghuidefu.com/api/code/huidiaoPost', // https://accountapi.kangou.cn/api/code/huidiaoPost
              source: 3,
              isRecharge: 1,
              openId: this.openId
           }
            
              let inteUrl = `https://pay.kangou.cn/paycenter/api/card/toRechargePage/?businessId=${res.data.businessId}&userId=${this.userId}&time=${res.data.time}&sign=${res.data.sign}&channel=${this.channel}&data=${encodeURIComponent(JSON.stringify(dataJson))}`

            window.location.href = inteUrl

        }
      
    },
    // 跳转积分的事件
    ToJifen() {
       window.location.href = this.toJifenUrl
    },
    // 图标链接地址    
    ToIconUrl(href) {
     
      if (href) {
        href.includes('userSign=') ? window.location.href = href + this.sign :
         window.location.href = href 
         if (href.includes('h5addressList')) {
          window.location.href = href + '&person=my' 
        }
      }
    },
    // 图标链接地址    
    ToDingdan() {
       window.location.href = `https://${window.location.host}/orderList.html?#/`
    }
  },
};
</script>

<style lang="stylus">
@import '../../assets/css/common.styl';
@import '../../assets/css/icon.css';
@import '../../assets/css/stylesheet.css';

.h5mycenterPage {
  // overflow: auto;
  width: 100%;
  height: auto;
  // height: 2112px;
   background: #F7F7F7 !important;
  font-family: Source Han Sans CN;
  overflow-y: hidden;
}

.mysettingright {
  width: calc(100% - 48px);
  background: #F7F7F7;
  margin: 0px auto;
  display flex
  justify-content flex-end
  align-items center
  padding: 35px 0
  div {
    // width: 180px;
    width: 120px;
    display flex
    justify-content space-between
    align-items center
  }
  img:nth-child(1)  {
    width: 40.87px;
    height: 41.18px;
  }
  img:nth-child(2)  {
    width: 38.82px;
    height: 37.04px;
  }
  img:nth-child(3)  {
    width: 36.83px;
    height: 36.83px;
  }
}

.myuser {
  display flex
  justify-content space-between
  align-items center
  margin 10px auto

  .left {
    margin-left 12px
    display flex
    align-items center
    
    .header {
      width: 122px;
      height: 122px;
      border-radius: 50%;
      overflow hidden
      margin-left: 30px;
    }
    .header img{
      width 100%
      border-radius: 50%;
      object-fit cover;
    }

    .name {
       margin-left 20px
       .nickname {
        font-size: 30px;
        font-weight: bold;
        color: #333333;
       }
       .userid {
         padding-top: 6px;
        font-size: 24px;
        font-weight: 400;
        color: #999999;
       }
    }
  }

.right {
    width: 294px;
    height: 126px;
    background: #FFFFFF;
    box-shadow: 0px 1px 11px rgba(248, 169, 178, 0.09);
    opacity: 1;
    border-radius: 63px 0px 0px 63px;

    display: flex;
    align-items: center;
  }

  .right .box {
    width: 75%;
    margin: 0 auto;

    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .box_left  {
    width: 80px;
    height: auto;
    text-align: center;
    > img {
      display: inline-block;
      width: 42.92px;
      height: 44.48px;
    }
    > span {
       display: inline-block;
       font-weight: 400;
       color: #666666;
       font-size: 14px;
    }
  }
   

  .box_right .num {
    display: flex;
    align-items: center;
    width: 70px;
    height: 36px;
    font-size: 36px;
    font-weight: 400;
    line-height: 61px;
    color: #EF1C34;
  }

  .box_right .num img {
    margin-left: 15px;
    width: 8.9px;
    height: 16.04px;
  }

}



.my_order {
  width: calc(100% - 48px);
  margin: 0px auto;
  display: flex;
  justify-content space-between;
  align-items center
  padding: 25px 0 50px 0;
  .left {
    width: 128px;
    height: 32px;
    font-size: 32px;
    font-family: Source Han Sans CN;
    font-weight: 600;
    color: #333333;
    opacity: 1;
  }

  .right {
    height: 24px;
    font-size: 24px;
    color: #999999;

    display flex
    display: -webkit-flex; 
    align-items center
    > img {
      width: 10.44px;
      margin-left: 15px;
      vertical-align middle
    }
  }
}



.order_container {
   width: calc(100% - 48px);
   margin: 0 auto;

    height: 316px;
    background: #FFFFFF;
    box-shadow: 0px 1px 11px rgba(248, 169, 178, 0.09);
    border-radius: 20px;
  
  .info {
    width: 100%;
    margin: 0 auto;

     display flex
     align-items center
     flex-wrap wrap
  }
}
.mynavcard {
  background: #F7F7F7 !important;
  width: calc(100% - 12px) !important;
}
 .order_container .info .img  {

   width: 23%;
   margin-left: 1.2%;
   margin-top: 36px;
   text-align: center;
     > img {
       width: 67px;
       height: 67px;
       display: inline-block;
    }

    > div {
      height: 24px;
      font-size: 24px;
      font-weight: 400;
      line-height: 41px;
      color: #999999;
    }

 }

.my_lunbo {
    width: 702px;
    height: 168px;
    margin: 20px auto;
    border-radius: 20px;
    overflow: hidden;
}

.wc_1swiper {
  
   width: 702px;
   height: 168px;

   .my_lunbo_img {
     width 9.36rem !important;
     height 2.24rem !important;
    border-radius: 20px;
    object-fit: cover;
  }

}

.my_channer {
   width: calc(100% - 48px);
   margin: 0px auto;
   padding: 25px 0;
   display flex
   justify-content space-between
   align-items center

  .left {
    height: 32px;
    font-size: 32px;
    font-weight: 600;
    line-height: 32px;
    color: #333333;
    opacity: 1;
  }
   > img {
      width: 10.44px;
      height: 18.83px; 
      margin-left: 15px;
   }
}

.otherChannel {
  width: calc(100% - 48px);
  margin: 20px auto;

  display flex
  justify-content space-between
  align-items center
  flex-wrap wrap
}


.my_footer_movie {
    width: calc(100% - 48px);
    margin: 0px auto;
    margin-bottom 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    .box {
      width: 341px;
      height: 420px;
      background: #FFFFFF;
      border-radius: 20px;
      margin-bottom: 28px;

      display flex
      justify-content center
      align-items center
    }
   
   .box_one {
     > img {
      //  width: 41.76px;
       width: 40px;
       height: auto;
       margin-right: 10px;
       object-fit: cover;
     }

      width: 306px;
      height: 30px;
      font-size: 30px;
      font-weight: 600;
      color: #333333;
      margin: 0 auto;

      display flex
      align-items center
   }

   .box_two {
    width: 306px;
    height: 230px;
    border: 1px solid #F7F7F7;
    border-radius: 10px;
    margin: 20px auto;
    > img {
      width: 100%;
      height: 100%;
    }
   }

   .box_three {
     width: 306px;
     text-align center

     span {
       display: inline-block;
       width: 202px;
      height: 56px;
      background: #FFFFFF;
      border: 1px solid #EF1C34;
      border-radius: 30px;

      font-size: 26px;
      font-weight: 400;
      line-height: 56px;
      color: #EF1C34;
     }
   }

   .box_three1 {
     width: 306px;
     display flex
     justify-content space-around
     align-items center

     span{
      display: inline-block;
      width: 125px;
      height: 45px;
      background: #FFFFFF;
      border: 1px solid #EF1C34;
      border-radius: 30px;

      display flex
      justify-content center
      align-items center
      font-size: 18px;
      font-weight: 400;
      color: #EF1C34;
     }
   }
}

.otherChannel .channel_box{
  width: 341px;
  height: 420px;
  background: #FFFFFF;
  opacity: 1;
  border-radius: 20px;

  .up {
    display flex
    align-items center

    font-size: 30px;
    font-family: Source Han Sans CN;
    font-weight: 600;
    color: #333333;

    > img {
      width: 41px;
      height: 36px;
    }
  }

  .center {
    width: 306px;
    height: 230px;
    background: rgba(0, 0, 0, 0);
    border: 1px solid #F7F7F7;
    opacity: 1;
    border-radius: 10px;
  }

    .down {
      width: 100%;
      display flex
      justify-content space-around
      align-items center
      .buying {
        width: 101px;
        height: 56px;
        background: #FFFFFF;
        border: 1px solid #EF1C34;
        opacity: 1;
        border-radius: 30px;

        display flex
        justify-content center
        align-items center

        font-size: 26px;
        font-weight: 400;
        color: #EF1C34;
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/my/index.vue